import React from 'react';
import {Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import GwStatusInfo from "./GwStatusInfo";
import RptStatusInfo from "./RptStatusInfo";
import SensorStatusInfo from "./SensorStatusInfo";

// 상태정보
const StatusInfo = ({
                      propType = 'gateway',
                      propName = '게이트웨이',
                      propFcltyID,
                      propRpeatNo = null,
                      propSensorNo = null
                    }) => {

  return (
      <Container fluid className={"layer p-2"}>
        <Row className={'py-2 mx-2'}>
          {propType === 'gateway' ?
              <GwStatusInfo
                  propType={"gateway"}
                  propName={"게이트웨이"}
                  propFcltyID={propFcltyID}
              /> : ''}
          {propType === 'Rep' ?
              <RptStatusInfo
                  propType={"repeater"}
                  propName={"중계기"}
                  propFcltyID={propFcltyID}
                  propRpeatNo={propRpeatNo}
              /> : ''}
          {propType === 'Fire' ?
              <SensorStatusInfo
                  propType={"fireDtctr"}
                  propName={"화재센서"}
                  propFcltyID={propFcltyID}
                  propSensorNo={propSensorNo}
              /> : ''}
          {propType === 'Motion' ?
              <SensorStatusInfo
                  propType={"mobileDtctr"}
                  propName={"움직임감지기"}
                  propFcltyID={propFcltyID}
                  propSensorNo={propSensorNo}
              /> : ''}
          {propType === 'Bell' ?
              <SensorStatusInfo
                  propType={"emergency"}
                  propName={"비상벨"}
                  propFcltyID={propFcltyID}
                  propSensorNo={propSensorNo}
              /> : ''}
        </Row>
      </Container>
  );
};

export default StatusInfo;
